<nav class="pos-navbar">
    <div class="pos-logo">
        <img src="./assets/images/logo/logo-Socialite-POS.svg"/>
    </div>
    <div class="pos-venue-dropdown w-100">
        <div *ngIf="venues.length > 0" class="soc-input-lbl">{{'NAVBAR.VENUE'|translate}}</div>
        <p-dropdown class="soc-dropdown soc-dropdown-search-separator" *ngIf="currentVenue != null && venues.length > 0"  [(ngModel)]="currentVenue" [virtualScroll]="true" [itemSize]="5" [filter]="true" [options]="venues" optionLabel="name" placeholder="Select venue" filterPlaceholder="Search..." [optionValue]="'id'">
            <ng-template let-item pTemplate="item">
                <a [routerLink]="[item.id, 'dashboard']">{{item.name}}</a>
            </ng-template>
        </p-dropdown>
    </div>
    <ul class="pos-nav">
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'dashboard']" [class.disabled]="venues.length == 0">
                <span class="material-icons">dashboard</span><span>{{'NAVBAR.DASHBOARD'|translate}}</span>
            </a>
        </li>
    </ul>
    <span class="pos-ul-title">{{'NAVBAR.FACILITIES'|translate}}</span>
    <ul class="pos-nav">
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'inventory']" [class.disabled]="venues.length == 0">
                <span class="material-icons">inventory</span><span>{{'NAVBAR.INVENTORY'|translate}}</span>
            </a>
        </li>
        <li class="pos-nav-item" routerLinkActive="pos-active-link"> 
            <a [routerLink]="[this.currentVenue, 'division']" [class.disabled]="venues.length == 0">
                <span class="divisions-icon nav-icon"></span><span>{{'NAVBAR.DIVISIONS'|translate}}</span>
            </a>
        </li>
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'supplier']" [class.disabled]="venues.length == 0">
                <span class="material-icons-round">store</span><span>{{'NAVBAR.SUPPLIERS'|translate}}</span>
            </a>
        </li>
    </ul>
    <span class="pos-ul-title">{{'NAVBAR.SERVICE'|translate}}</span>
    <ul class="pos-nav">
        <li class="pos-nav-item" routerLinkActive="pos-active-link"> 
            <a [routerLink]="[this.currentVenue, 'menuV2']" [class.disabled]="venues.length == 0">
                <span class="material-icons">restaurant_menu</span><span>{{'NAVBAR.MENU'|translate}}</span>
            </a>
        </li>
        <li class="pos-nav-item" routerLinkActive="pos-active-link"> 
            <a [routerLink]="[this.currentVenue, 'groups']" [class.disabled]="venues.length == 0">
                <span class="material-icons">room_service</span><span>{{'NAVBAR.GROUPS'|translate}}</span>
            </a>
         </li>
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'tax-rate']" [class.disabled]="venues.length == 0">
                <span class="tax-icon nav-icon"></span><span>{{'NAVBAR.TAX_RATES'|translate}}</span>
            </a>
        </li>
    </ul>
    <span  class="pos-ul-title">{{'NAVBAR.MANAGEMENT'|translate}}</span>
    <ul  class="pos-nav">
        <li class="pos-nav-item" routerLinkActive="pos-active-link"> 
            <a [routerLink]="[this.currentVenue, 'manager-employees']" [class.disabled]="venues.length == 0">
                <span class="schedule-icon nav-icon"></span><span>{{'NAVBAR.SCHEDULE'|translate}}</span>
            </a>
         </li>
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'turnover']" [class.disabled]="venues.length == 0">
                <span class="orders-icon nav-icon"></span><span>{{'NAVBAR.TURNOVER'|translate}}</span>
            </a>
        </li>
    </ul>
    <span *ngIf="isUserGeneralManager()" class="pos-ul-title">{{'NAVBAR.ADMINISTRATION'|translate}}</span>
    <ul *ngIf="isUserGeneralManager()" class="pos-nav">
        <li class="pos-nav-item" routerLinkActive="pos-active-link">
            <a [routerLink]="[this.currentVenue, 'employees']" [class.disabled]="venues.length == 0">
                <span class="material-icons">person</span><span>{{'NAVBAR.EMPLOYEES'|translate}}</span>
            </a>
        </li>
    </ul>
</nav>
